import React from 'react'
import { FormattedMessage } from 'react-intl'

import ramblaLogo from '../../../assets/svg/rambla-logo.svg'
import hausmartLogo from '../../../assets/svg/Hausmart_logo_notype_white.svg'
import { RAMBLA_URL, HAUSMART_GET_STARTED_URL } from '../../../constants/appLinks'
import {
  ProductsSection,
  ProductsIntro,
  ProductsHeading,
  ProductsLead,
  ProductGrid,
  ProductCard,
  ProductLogo,
  ProductName,
  ProductTagline,
  ProductBody,
  ProductCta,
  ProductLink
} from './ProductsStyledComponents'

const Products = () => (
  <ProductsSection>
    <ProductsIntro>
      <ProductsHeading>
        <FormattedMessage id="homepage.products.heading" />
      </ProductsHeading>
      <ProductsLead>
        <FormattedMessage id="homepage.products.intro" />
      </ProductsLead>
    </ProductsIntro>
    <ProductGrid>
      <ProductCard $tone="rambla">
        <ProductLogo $tone="rambla" $src={ramblaLogo} aria-hidden="true" />
        <ProductName>
          <FormattedMessage id="homepage.products.rambla.name" />
        </ProductName>
        <ProductTagline>
          <FormattedMessage id="homepage.products.rambla.tagline" />
        </ProductTagline>
        <ProductBody>
          <FormattedMessage id="homepage.products.rambla.body" />
        </ProductBody>
        <ProductCta>
          <ProductLink href={RAMBLA_URL}>
            <FormattedMessage id="homepage.products.rambla.cta" />
          </ProductLink>
        </ProductCta>
      </ProductCard>
      <ProductCard $tone="hausmart">
        <ProductLogo $tone="hausmart" $src={hausmartLogo} aria-hidden="true" />
        <ProductName>
          <FormattedMessage id="homepage.products.hausmart.name" />
        </ProductName>
        <ProductTagline>
          <FormattedMessage id="homepage.products.hausmart.tagline" />
        </ProductTagline>
        <ProductBody>
          <FormattedMessage id="homepage.products.hausmart.body" />
        </ProductBody>
        <ProductCta>
          <ProductLink href={HAUSMART_GET_STARTED_URL}>
            <FormattedMessage id="homepage.products.hausmart.cta" />
          </ProductLink>
        </ProductCta>
      </ProductCard>
    </ProductGrid>
  </ProductsSection>
)

Products.displayName = 'Products'

export default Products
